import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { faqs } from '../data/mock';

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section 
      id="faq" 
      className="section-dark"
      style={{ background: 'var(--bg-wood)' }}
    >
      <div className="container max-w-3xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span 
            className="inline-block px-4 py-2 rounded-full mb-4 font-display text-sm uppercase tracking-widest"
            style={{ 
              background: 'rgba(212, 168, 75, 0.15)',
              border: '1px solid var(--border-gold)',
              color: 'var(--gold-primary)'
            }}
          >
            Common Questions
          </span>
          <h2 className="heading-1 text-gold mb-4">
            Frequently Asked Questions
          </h2>
          <p 
            className="body-large"
            style={{ color: 'var(--text-muted)' }}
          >
            Everything you need to know about laser wood borer treatment.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="card-wood"
              style={{ padding: 0, overflow: 'hidden' }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full p-5 flex items-center justify-between text-left bg-transparent border-none cursor-pointer"
              >
                <span 
                  className="heading-3 pr-4"
                  style={{ color: openIndex === index ? 'var(--gold-primary)' : 'var(--text-light)' }}
                >
                  {faq.question}
                </span>
                <span 
                  className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center"
                  style={{ 
                    background: openIndex === index ? 'var(--gold-primary)' : 'transparent',
                    border: '1px solid var(--gold-primary)'
                  }}
                >
                  {openIndex === index ? (
                    <ChevronUp 
                      size={18} 
                      style={{ color: openIndex === index ? 'var(--bg-dark)' : 'var(--gold-primary)' }} 
                    />
                  ) : (
                    <ChevronDown 
                      size={18} 
                      style={{ color: 'var(--gold-primary)' }} 
                    />
                  )}
                </span>
              </button>
              
              {/* Animated Content */}
              <div 
                className="overflow-hidden transition-all duration-300 ease-in-out"
                style={{ 
                  maxHeight: openIndex === index ? '300px' : '0',
                  opacity: openIndex === index ? 1 : 0
                }}
              >
                <div 
                  className="px-5 pb-5 body-medium"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
